import detail_card from './detail_card';

export default {
    detail_card,
}
